import history from "../routes/history"
export const BASEURL = "https://sistema.classeloc.com.br/api/v3"
export const path = "/area-do-cliente"

export const getToken = () => {
    let token = sessionStorage.getItem("token")
    return token
}
export const COLORS = {
    verde: "#296941",
    vermelho: "#C14039"
}

export const downloadFile = (url, filename) => {
    return new Promise((resolve, reject) => {
        fetch(`${BASEURL}${url}`, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + getToken()
            })
        })
            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob)
                var a = document.createElement("a")
                a.href = url
                a.download = filename
                document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click()
                a.remove() //afterwards we remove the element again
                resolve(filename)
            })
            .catch(err => reject(err))
    })
}

export const logout = () => {
    //window.sessionStorage.removeItem("token")
    //window.sessionStorage.removeItem("user")
    history.push(path + "/login")
}

export const isAuthenticated = () => {
    let token = getToken()
    if (token) {
        return true
    } else {
        return false
    }
}

export const isAtrasado = date => {
    let [dia, mes, ano] = date.split("/")
    mes = parseInt(mes) - 1
    let vencimento = ano + "-" + mes + "-" + dia
    let d = new Date()
    let hoje = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate()
    if (vencimento < hoje) {
        return true
    } else {
        return false
    }
}

export const CNPJ = cnpj => {
    cnpj = cnpj.replace(/\D/g, "")
    cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2")
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2")
    cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2")
    return cnpj
}
export const CPF = cpf => {
    cpf = cpf.replace(/\D/g, "")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    return cpf
}
export const CEP = cep => {
    cep = cep.replace(/\D/g, "")
    cep = cep.replace(/^(\d{2})(\d)/, "$1.$2")
    cep = cep.replace(/\.(\d{3})(\d)/, ".$1-$2")
    return cep
}

export const removerAcentos = newStringComAcento => {
    let string = newStringComAcento
    let mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
    }

    for (let letra in mapaAcentosHex) {
        let expressaoRegular = mapaAcentosHex[letra]
        string = string.replace(expressaoRegular, letra)
    }

    return string
}

export const filtro = (collection, param, text) => {
    return collection.filter(item => {
        let itemData = removerAcentos(item[param].toLowerCase())
        let textData = removerAcentos(text.toLowerCase())
        return itemData.indexOf(textData) > -1
    })
}
